import styled from '@emotion/styled';
import { COLORS3 as COLORS, MEDIA_QUERY } from '../../styles/emotion';

export const FeaturedImageWrapper = styled.div<{ backgroundColor?: string }>`
  align-items: center;
  border-radius: var(--border-radius-md, 16px);
  display: flex;
  height: 200px;
  justify-content: center;
  max-height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;

  ${MEDIA_QUERY.TABLET} {
    height: 376px;
  }

  ${MEDIA_QUERY.DESKTOP} {
    height: 100%;
    width: auto;
  }

  ${({ backgroundColor }) =>
    backgroundColor &&
    `
      background-color: ${backgroundColor};
  `};
`;

export const StyledPicture = styled.picture`
  background-color: ${COLORS.BLACK_015};
  border-radius: var(--border-radius-md, 16px);
  height: 100%;
  width: 100%;
`;

export const StyledBackgroundImage = styled.img`
  border-radius: var(--border-radius-md, 16px);
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

export const ForegroundImagesWrapper = styled.div<{ isWithBackgroundImage: boolean }>`
  align-items: center;
  bottom: 0;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;

  ${MEDIA_QUERY.DESKTOP} {
    height: 90%;
    width: 90%;
  }

  ${({ isWithBackgroundImage }) =>
    isWithBackgroundImage &&
    `
    height: 90%;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 90%;
  `}
`;

export const StyledForegroundPicture = styled.picture`
  align-items: center;
  display: flex;
  height: 100%;
  justify-items: center;

  ${MEDIA_QUERY.DESKTOP_XL} {
    display: contents;
  }
`;

export const StyledForegroundImage = styled.img`
  max-height: 90%;
  max-width: 100%;

  ${MEDIA_QUERY.DESKTOP_XL} {
    margin: auto;
    max-height: 100%;
  }

  ${MEDIA_QUERY.MOBILE} {
    margin: auto;
    max-height: 100%;
  }
`;
